import React, { useMemo } from 'react';
import { Input, InputGroup, InputLeftElement } from '@chakra-ui/react';
import styled from '@emotion/styled/macro';

import { ReactComponent as SearchIcon } from '../../icons/search.svg';
import debounce from 'lodash/debounce';

const SearchBar = ({ textHolder, onChange, variant = 'filled', ...rest }) => {
    const debouncedValue = useMemo(() => debounce(onChange, 250), [onChange]);

    return (
        <InputGroup>
            <InputField
                type="text"
                variant={variant}
                onChange={(e) => debouncedValue(e.target.value)}
                placeholder={textHolder}
                {...rest}
            />
            <InputLeftElement pointerEvents="none" children={<SearchIcon color="gray.600" />} />
        </InputGroup>
    );
};

const InputField = styled(Input)`
    height: 36px;
    color: var(--chakra-colors-black);
    padding-left: 40px;
    padding-right: 16px;

    &:hover + div svg path {
        fill: var(--chakra-colors-gray-800);
    }

    &:focus {
        border-color: var(--chakra-colors-blue-400);
    }

    &:focus + div svg path {
        fill: var(--chakra-colors-blue-400);
    }
`;

export default SearchBar;
